import { render } from "./2.ProductImages.vue?vue&type=template&id=df37bae4&scoped=true"
import script from "./2.ProductImages.vue?vue&type=script&lang=js"
export * from "./2.ProductImages.vue?vue&type=script&lang=js"

import "./2.ProductImages.vue?vue&type=style&index=0&id=df37bae4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df37bae4"]])

export default __exports__